import React, { createContext, useContext, useMemo } from 'react';
import { GroupedPlans } from '@common-fe/common-fe';

interface PlanTemplatesContextValue {
  formattedTemplates: GroupedPlans[] | undefined;
  isLoading: boolean;
}

const PlanTemplatesContext = createContext<PlanTemplatesContextValue>({
  formattedTemplates: undefined,
  isLoading: false,
});

export const usePlanTemplatesContext = () => useContext(PlanTemplatesContext);

interface Props {
  formattedTemplates: GroupedPlans[] | undefined;
  isLoading: boolean;
  children: React.ReactNode;
}

/**
 * Provides shared plan templates data for all PayoutOrderPlanDropdown instances.
 * Avoids prop drilling through multiple levels of nesting.
 */
export const PlanTemplatesProvider: React.FC<Props> = ({ formattedTemplates, isLoading, children }) => {
  const value = useMemo(() => ({ formattedTemplates, isLoading }), [formattedTemplates, isLoading]);

  return <PlanTemplatesContext.Provider value={value}>{children}</PlanTemplatesContext.Provider>;
};
